<template>
  <div></div>
</template>

<script>
import {
  getSettings,
  updateBusinessSettings,
  updateHoursSettings,
  updateOwnerSettings,
} from "@/api/business-settings";
import { getBusinessInfo } from "@/api/business";
import Liveagent from "../../components/liveagent/LiveAgent";
import axios from "axios";

export default {
  name: "liveagent",
  data() {
    return {
      settings: {
        email: "",
        name: "",
        t590uid: "",
        rnduid: "",
      },
    };
  },

  created() {
    getSettings().then((response) => {
      this.settings = response.data;
      localStorage.setItem("rnd-bemail", this.settings.email);
      localStorage.setItem("rnd-uname", this.settings.name);
    });
  },
  mounted() {},
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/components/liveagent/LiveAgent.vue